module.exports = __webpack_public_path__ + "static/media/1022067.116d6ba6.jpg";